import baseApi from "./baseApi"

var debug = false;

export default {

    async getPestConfigurations(plantIDs) {
        var plantIDsString = plantIDs;
        
        if (Array.isArray(plantIDs) && plantIDs.length > 0) {
            plantIDsString = plantIDs.join(",");
        }

        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/scout/pestconfigurations?plantIDs=${plantIDsString}`);
        return result.data;
    },

    async getScoutings(plantIDs) {
        var plantIDsString = plantIDs;

        if (Array.isArray(plantIDs) && plantIDs.length > 0) {
            plantIDsString = plantIDs.join(",");
        }

        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/scout/scoutings?plantIDs=${plantIDsString}`);
        return result.data;
    },

    async batchProcessUnsyncedScoutings(scoutings, plantIDs) {
        if (debug) console.log(`batchProcessUnsyncedScoutings, scoutings:`, JSON.stringify(scoutings));

        var plantIDsString = plantIDs;
        if (Array.isArray(plantIDs) && plantIDs.length > 0) {
            plantIDsString = plantIDs.join(",");
        }

        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/scout/batch?plantIDs=${plantIDsString}`, scoutings);
        return result.data;
    },

    async getScoutingCropStages() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/scout/cropStages");
        return result.data;
    },

    async addScoutingCropStage(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/scout/cropStages", item);
        return result.data;
    },

    async updateScoutingCropStage(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/scout/cropStages", item);
        return result.data;
    },

    async getScoutingScoreScales() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/scout/scoreScales");
        return result.data;
    },

    async addScoutingScoreScale(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/scout/scoreScales", item);
        return result.data;
    },

    async updateScoutingScoreScale(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/scout/scoreScales", item);
        return result.data;
    },

    async getScoutingOverview(id) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/scout/overview/${id}`);
        return result.data;
    },
}